<template>
    <div>
      <el-row style="margin-bottom: 24px;border-bottom: 1px solid #ddd;">
        <el-col :span="16" style="vertical-align: middle;">
          <h1>{{page_structure['name']}}</h1>
        </el-col>
        <el-col :span="8" style="text-align: right;vertical-align: middle;">
          <el-button icon="el-icon-view" @click="handle_view_button_click">回到檢視</el-button>
          <el-button icon="el-icon-edit" @click="handle_save_button_click">儲存變更</el-button>
        </el-col>
      </el-row>
      <el-row>
        <EditViewForm 
          :handle_dynamic_form_update="handle_dynamic_form_update"
          :handle_file_upload="()=>{}"
          :page_structure="page_structure"
          :preloaded_data="context"
          mode="edit"
          :preloaded_data_update_flag="preloaded_data_update_flag"
          />
      </el-row>
      <LoadingBlock :active="loading"></LoadingBlock>
    </div>
</template>

<script>
import axios from 'axios'
import _ from 'lodash'
import LoadingBlock from '@/components/backstage/LoadingBlock/LoadingBlock.vue'
import PageStructure from '@/views/backstage/structure/my_issue_report_page/MyIssueReportEditStructure.js'
import EditViewForm from '@/components/backstage/EditViewForm/EditViewForm.vue'
import breadcrumbMixin from '@/mixins/breadcrumbMixin'

export default {
    mixins: [breadcrumbMixin],
    components: {
      LoadingBlock,
      EditViewForm
    },
    data() {
      return {
        loading: false,//TODO: change this to true,
        page_structure: [],
        context: {}, 
        resource_api: process.env.VUE_APP_API_BACKSTAGE_URL + '/issue-report',
        report_id: null,
        preloaded_data_update_flag: 0
      }
    },
    created: async function () {
        console.log('MyIssueReportEdit: route id:', this.$route.params.id)

        if (!this.$route.params.id) {
          return 
        }

        this.page_structure = PageStructure(this.$route.params.type)
        console.log('MyIssueReportEdit: page structure:', this.page_structure)    
        this.report_id = this.$route.params.id
        console.log('MyIssueReportEdit: report id:', this.report_id)

        await this.get_context()
    },
    methods: {      
      handle_view_button_click () {
        console.log('view button clicked')
        this.backstage_router_push({ path: `/my-issue-report/view/${this.report_id}` })
      },     
      async get_context () {

        this.loading = true
        
        axios.get(this.resource_api+'/get', {params: {id:this.report_id}})
            .then((response) => {
              this.loading = false
              console.log('reponse: ', response.data.payload)
              if (response.data.success) {
                this.$set(this, 'context', this.translate_to_display_data(this.page_structure, response.data.payload))
                this.update_breadcrumbs_title(this.context['content'])
              }
              else {
                this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得資料', response.data.message)
              }
            })
            .catch(err => {
                this.loading = false
                console.log(err)
                this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得資料', this.ERROR.MSG.general_err_msg)
            })
      },
      handle_save_button_click () {
        console.log('save button clicked')

        if (!this.report_id) {
          console.log('[ERR] MyIssueReportEdit: saving with no report_id')
        }

        let param = this.translate_to_form_data(this.page_structure, this.context)

        param.append('id', this.report_id);

        let config = { headers:{'Content-Type':'multipart/form-data'} } 

        axios.post(this.resource_api+'/edit', param, config)
          .then (response => { 
            if (!response.data.success) {
              console.log('save/edit failed, msg='+response.data.message+', reponse=', response)
              this.notify_message(this.ERROR.LEVEL.ERROR, '新增/編輯失敗', response.data.message)
              return
            }

            console.log('save/edit succeed, response=', response)

            this.backstage_router_push({ path: `/my-issue-report/view/${this.report_id}` })
          }) 
          .catch(({err}) => { 
            console.log('save/edit failed, err=', err)
            this.notify_message(this.ERROR.LEVEL.ERROR, '新增/編輯失敗', this.ERROR.MSG.general_err_msg)
          }) 
      },
      handle_dynamic_form_update (key, form_value) {
        console.log('MyIssueReportEdit: handle_dynamic_form_update:' + key + ', value:', form_value)

        this.$set(this.context, key, form_value)
      }
    }
  }

</script>

<style lang="scss" scoped>

.action_buttons {
  float: right;
  .el-button {
    margin-right: 22px;
  }
}

.choices-radio{
  margin-bottom: 22px;
}

.clearfix::after {
    content: "";
    clear: both;
    display: table;
}

.field {
  padding: 5px;
  background-color: rgba(25, 111, 61, 0.1);
  width: 200px;
  vertical-align: top;
  &+.value {
    vertical-align: top;
    padding: 5px;
  }
}
</style>
